module.exports = __webpack_public_path__ + "static/img/10.680c771.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/10.png
// module id = 15Ct
// module chunks = 0